export const DEAL_CLOSURE_DATE = "dealClosureDate";
export const DEAL_AMOUNT = "dealAmount";
export const INCLUDES_GST = "isGstIncluded";
export const PDCS_COLLECTED = "pdcsCollected";
export const SALES_PERSON_TYPE = "salesPersonType";
export const DEAL_CLOSED_BY = "dealClosedBy";
export const LEAD_TYPE = "leadType";
export const CONTRACT_YEARS = "contractYears";
export const PAYMENT_FROM_ENTITY = "paymentFromEntity";
export const EXPECTED_LAUNCH_DATE = "expectedLaunchDate";
export const AGREEMENT_DOCUMENT = "agreementDocument";
export const AGREEMENT_DOCUMENT_FILE_NAME = "agreementDocumentFileName";

// Installment Schedule
export const INSTALLMENT = "installment";
export const INSTALLMENT_YEAR = "installmentYear";
export const INSTALLMENT_NUMBER = "installmentNumber";
export const EXPECTED_DUE_DATE = "expectedDueDate";
export const INSTALLMENT_AMOUNT = "installmentAmount";

export const GST_PERCENTAGE = "gstNotes";
export const INSTALLMENT_AMOUNT_NON_GST = "installmentAmountNonGst";
export const INSTALLMENT_AMOUNT_GST = "installmentAmountGst";
export const TOTAL_INVOICE_AMOUNT = "totalInvoiceAmount";
export const TDS = "isTDSDeducted";
export const YEAR = "year";

export const GENERATED_BY = "year";
export const GENERATED_DATE = "genyear";

export const MOU_AMOUNT = "mouAmount";
export const INTEREST_PERCENTAGE = "interestPercentage";
export const INTEREST_AMOUNT = "interestAmount";

export const salesPersonTypeOptions = [
  { label: "Inside", value: "Internal" },
  { label: "Field", value: "External" },
];

export const leadTypeOptions = [
  { label: "Inbound", value: "Inbound" },
  { label: "Outbound", value: "Outbound" },
];

export const pdcOptions = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

export const gstIncludesOptions = [
  { label: "Included", value: "Included" },
  { label: "Not Included", value: "Not Included" },
]